import React from "react";
import {useTranslation} from "react-i18next";
import ListLoader from "../../../utils/loader/ListLoader";
import styles from "./LoginForm.module.scss";
import KnownCustomer from "../../../checkout/steps/Login/KnownCustomer/KnownCustomer";

const LoginForm: React.FC<{onLoggedIn?: () => void}> = ({onLoggedIn}) => {
  const {t} = useTranslation();

  return (
    <React.Suspense fallback={<ListLoader />}>
      <KnownCustomer onLoggedIn={onLoggedIn} />
      <div className={styles.linksWrapper}>
        <p className={styles.linksHeader}>{t("customer.noCustomerYet")}</p>
        <a
          className={styles.linksButton + " " + "button button-white"}
          href={t("url.customerRegistrationLink")}
        >
          {t("customer.registerNow")}
        </a>
      </div>
    </React.Suspense>
  );
};

export default LoginForm;
